/* eslint-disable prefer-regex-literals */
/* eslint-disable no-param-reassign */
window.globalObject = {
  composeIsRichMode: false,
  backgridSortDirection: null,
  lastKeyCode: 0,
  currentComposeMessage: null,
  lastActiveQuickReportId: '',
  documentTitle: '',
  idleTracker: {
    keydown: Date.now(),
    mouse: Date.now(),
  },
  flags: {
    messageSendInProgress: false,
    localStorageAvailable: true,
  },
  engageCounters: {
    inbox: 0,
    scheduled: 0,
    scheduledTeam: 0,
    forMe: 0,
    forOthers: 0,
  },

  init() {
    window.globalObject.resizeManager.init();
    window.globalObject.setLocalDaysofWeek();
  },

  getUrlParameter(sParam) {
    const sPageURL = decodeURIComponent(window.location.search.substring(1));
    const sURLVariables = sPageURL.split('&');
    let sParameterName;
    let i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  },

  detectBottomReached(el, checkEl) {
    const excess = 50;
    const $el = $(el);

    checkEl = checkEl ? $(checkEl)[0].scrollHeight : document.body.offsetHeight;

    if ($el.scrollTop() + $el.innerHeight() + excess >= checkEl) {
      return true;
    }
    return false;
  },

  resizeManager: {
    cbToRun: [],

    init() {
      let doit;

      $(window).resize(() => {
        clearTimeout(doit);
        doit = setTimeout(window.globalObject.resizeManager.windowResizing, 100);
      });
    },

    windowResizing() {
      let i = 0;
      const len = window.globalObject.resizeManager.cbToRun.length;

      for (i; i < len; i++) {
        window.globalObject.resizeManager.cbToRun[i]($(window).width(), $(window).height());
      }
    },

    onWindowResize(cb) {
      window.globalObject.resizeManager.cbToRun.push(cb);
    },

    removeLastAddedResizeEvent(func) {
      const cbToRunArray = window.globalObject.resizeManager.cbToRun;
      let matchedIndex = -1;

      for (let index = 0; index < cbToRunArray.length; index++) {
        if (cbToRunArray[index] === func) {
          matchedIndex = index;
        }
      }

      if (matchedIndex > -1) {
        window.globalObject.resizeManager.cbToRun.splice(matchedIndex, 1);
      }
    },

  },

  setLocalDaysofWeek() {
    const enDays = dictionary.common.daysOfWeek.en;
    const arDaysofWeek = enDays.split(' ');
    let i = 0;
    const len = arDaysofWeek.length;
    let arLocalDays;

    if (dictionary.common.daysOfWeek[$current_user.language]) {
      arLocalDays = dictionary.common.daysOfWeek[$current_user.language].split(
        ' ',
      );
    } else {
      arLocalDays = dictionary.common.daysOfWeek.en.split(' ');
    }

    window.globalObject.objDaysofWeek = {};

    for (i; i < len; i++) {
      window.globalObject.objDaysofWeek[arDaysofWeek[i]] = arLocalDays[i];
    }
  },

  capitalize(fullname, forceFirsLastOnly) {
    let initials = '';
    const temp = fullname.split(' ');

    if (forceFirsLastOnly && temp.length > 2) {
      fullname = `${temp[0]} ${temp[temp.length - 1]}`;
    }

    initials = fullname.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase());

    return initials.replace(/ /g, '');
  },

  toTitleCase(str) {
    return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  },

  formatNumber(n, decimals) {
    decimals = decimals >= 0 ? decimals : 0;
    let i = 0;
    let j = 0;
    let t = Math.floor(n * 10 ** decimals + 0.5).toString();
    while (t.length < decimals + 1) {
      t = `0${t}`;
    }

    i = t.length - decimals;

    if (decimals) {
      t = `${t.substr(0, i)}.${t.substr(i)}`; // insert decimal separator (a dot or comma)
    }

    if (t.charAt(0) == '-') {
      j = 1; // adjusts position because of the negative symbol
    }

    for (i = i - 3 - j; i > 0; i -= 3) {
      t = `${t.substr(0, i + j)},${t.substr(i + j)}`; // insert thousands separators (commas or dots)
    }

    return t;
  },

  tidyHTML(html) {
    const d = document.createElement('div');
    d.innerHTML = html;
    return d.innerHTML;
  },

  urlRegex: new RegExp(
    /https?:\/\/([\p{L}\p{N}\p{Emoji}\-_]+\.)+[\p{L}\p{N}\p{Emoji}-]+[^\p{Z}\s]*([^\p{Z}\p{P}]|\/)/,
    'gu',
  ),

  // from jquery validator code
  emailRegex: new RegExp(
    // eslint-disable-next-line
    /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i,
  ),

  // mailto regex a concation of custom and email regex
  // http://stackoverflow.com/questions/46155/validate-email-address-in-javascript#answer-1373724
  mailtoRegex: new RegExp(/^mailto:([^?]+)/i),

  videoExtensionRegex: new RegExp('(.mp4|.mov)s*$', 'gmi'),
  newVideoExtensionRegex: new RegExp('.?(mp4|mov)$', 'gmi'),
  canvaUrl: '',

  fileTypes: {
    imageFileTypes: {
      'image/png': ['.png'],
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/jpg': true,
      'image/gif': ['.gif'],
      'google-filetype': true,
    },

    pdfFileTypes: {
      'application/pdf': ['.pdf'],
    },

    videoFileTypes: {
      'video/mp4': ['.mp4'],
      'video/mpeg4': ['.mpeg4'],
      'video/mpeg': ['.mpeg'],
      'video/quicktime': ['.mov', '.qt'],
      'video/mkv': ['.mkv'],
      'video/wmv': ['.wmv'],
      'video/avi': ['.avi'],
      'video/flv': ['.flv'],
      'video/webm': ['.webm'],
    },
  },

  multipleRteServiceCategories: {
    twitter: {
      name: 'Twitter',
      displayName: 'Twitter',
      tabId: 'compose-twitter',
      imageSrc:
        '/s3_assets/icons/flat/v2/composebox/twitter.png',
    },
    facebook: {
      name: 'Facebook',
      displayName: 'Facebook',
      tabId: 'compose-facebook',
      imageSrc:
        '/s3_assets/icons/flat/v2/composebox/facebook.png',
    },
    googleMyBusiness: {
      name: 'Google business',
      displayName: 'Google Business',
      tabId: 'compose-googlemybusinesslocation',
      imageSrc:
        '/s3_assets/icons/flat/v2/composebox/googlemybusiness.png',
    },
    linkedin: {
      name: 'Linkedin',
      displayName: 'Linkedin',
      tabId: 'compose-linkedin',
      imageSrc:
        '/s3_assets/icons/flat/v2/composebox/linkedin.png',
    },
    pinterest: {
      name: 'Pinterest',
      displayName: 'Pinterest',
      tabId: 'compose-pinterest',
      imageSrc:
        '/s3_assets/icons/flat/v2/composebox/pinterest.png',
    },
    threads: {
      name: 'Threads',
      displayName: 'Threads',
      tabId: 'compose-threads',
      imageSrc:
        '/s3_assets/icons/flat/threads.svg',
      imageSrcAlt: 's3_assets/icons/flat/v2/composebox/threads.svg',
    },
    bluesky: {
      name: 'Bluesky',
      displayName: 'Bluesky',
      tabId: 'compose-bluesky',
      imageSrc:
        's3_assets/icons/flat/v2/composebox/bluesky.svg',
      imageSrcAlt: 's3_assets/icons/flat/v2/composebox/bluesky-white.svg',
    },
    tiktok: {
      name: 'TikTok',
      displayName: 'TikTok',
      tabId: 'compose-tiktok',
      imageSrc:
        '/s3_assets/icons/flat/tiktok.svg',
      imageSrcAlt: 's3_assets/icons/flat/v2/composebox/tiktok.svg',
    },
    instagram: {
      name: 'Instagram',
      displayName: 'Instagram',
      tabId: 'compose-instagram',
      imageSrc:
        '/s3_assets/icons/flat/v2/composebox/instagram.png',
    },
    youtube: {
      name: 'Youtube',
      displayName: 'YouTube',
      tabId: 'compose-youtube',
      imageSrc:
        '/s3_assets/icons/flat/v2/composebox/youtube.svg',
    },
    wordpress: {
      name: 'Wordpress',
      displayName: 'Wordpress',
      tabId: 'compose-wordpress',
      imageSrc:
        '/s3_assets/icons/flat/v2/composebox/wordpress.svg',
    },
    group: {
      name: 'Group',
      displayName: 'Lists',
      tabId: 'compose-group',
      imageSrc:
        '/s3_assets/icons/flat/v2/composebox/service-list.png',
    },
  },

  getMultipleRteServiceCategory: (function () {
    const accountTypeLookupCache = {};

    function getCategory(accountType) {
      let category; let categoryName; let
        i;

      for (i = 0; i < window.globalObject.multipleRteMainServiceCategories.length; i++) {
        category = window.globalObject.multipleRteMainServiceCategories[i];
        categoryName = category.name.toLowerCase();

        if (accountType.indexOf(categoryName) !== -1) {
          return category;
        }
      }
    }

    return function (accountType) {
      let category = null;

      if (accountType && typeof accountType === 'string') {
        accountType = accountType.toLowerCase();

        category = accountTypeLookupCache[accountType];
        if (typeof category === 'undefined') {
          category = getCategory(accountType);
          accountTypeLookupCache[accountType] = category;
        }
      }
      return category;
    };
  }()),
};

window.globalObject.multipleRteMainServiceCategories = [
  window.globalObject.multipleRteServiceCategories.twitter,
  window.globalObject.multipleRteServiceCategories.facebook,
  window.globalObject.multipleRteServiceCategories.googleMyBusiness,
  window.globalObject.multipleRteServiceCategories.linkedin,
  window.globalObject.multipleRteServiceCategories.pinterest,
  window.globalObject.multipleRteServiceCategories.tiktok,
  window.globalObject.multipleRteServiceCategories.threads,
  window.globalObject.multipleRteServiceCategories.bluesky,
  window.globalObject.multipleRteServiceCategories.instagram,
  window.globalObject.multipleRteServiceCategories.wordpress,
  window.globalObject.multipleRteServiceCategories.youtube,
  window.globalObject.multipleRteServiceCategories.group,
];

// Checks if an image exists at a particular url.
function isValidImage(src, callback) {
  // Create new offscreen image to test
  const image_new = new Image();
  image_new.onerror = function () {
    if (callback) {
      callback(false);
    }
  };
  image_new.onload = function () {
    if (this.width >= 48 && this.height >= 48) {
      if (callback) {
        callback(true, src);
      }
    } else if (callback) {
      callback(false);
    }
  };
  image_new.src = src;
  return true;
}

function trim(txt) {
  if (txt != null) {
    return txt.replace(/^\s+|\s+$/g, '');
  }
  return '';
}

function truncate(txt, max) {
  if (txt.length > max) {
    return `${txt.substring(0, max)}...`;
  }
  return txt;
}

function replaceAll(txt, replace, with_this) {
  if (!txt) return '';
  const reg = new RegExp(replace, 'g');
  return txt.replace(reg, with_this);
}

function checkAccountTypePresent(recipients, strAccount) {
  const strAccountTypes = _.pluck(recipients, 'account_type')
    .join(',')
    .toLowerCase();

  return strAccountTypes.indexOf(strAccount) !== -1;
}

function convertTagToLink(match) {
  const facebookId = /:?([0-9]+)/gim.exec(
    this.messageObject.facebookTagTable[this.index],
  );

  return facebookId
    ? `<a target='_blank' href='https://www.facebook.com/${
      facebookId[1]
    }'>${
      match
    }</a>`
    : match;
}

// Convert URL's in text into HTML links.
function linkify(
  text,
  linkClass,
  isInstagram,
  messageObject,
  forceCheckFBTags,
  noUrlLinkify,
) {
  let useFBLinks = false;
  let useThreadsLinks = false;
  let useBlueskyLinks = false;
  const urlRegex = /(=\s*["']\s*)?(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim;
  const imgRegex = /<img src=["']<a href='(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])["'][\s\S]*? \/?>/gi;

  if (!text) {
    return '';
  }

  if ((messageObject?.send_to_descriptions && messageObject.send_to_descriptions.toLowerCase().indexOf('instagram') !== -1)
      || (messageObject?.service_name && messageObject.service_name.toLowerCase().indexOf('instagram') !== -1)
      || (messageObject?.recipients && messageObject.recipients[0]?.account_type.toLowerCase().includes('instagram'))) {
    isInstagram = true;
  }

  linkClass = linkClass || '';
  if (!noUrlLinkify) {
    text = text.replace(urlRegex, ($0, $1) => ($1
      ? $0
      : `<a href='${
        $0
      }' class='${
        linkClass
      }' target='_blank' data-bypass>${
        $0
      }</a>`));
  }

  // handle images which were urls
  text = text.replace(imgRegex, "<img src='$1' />");

  // exclude twitter
  if (
    messageObject
    && messageObject.labeledTagTable
    && _.keys(messageObject.labeledTagTable)[0].indexOf('tw_') == -1
    && _.keys(messageObject.labeledTagTable)[0].indexOf('ig_') == -1
    && _.keys(messageObject.labeledTagTable)[0].indexOf('th_') == -1
    && _.keys(messageObject.labeledTagTable)[0].indexOf('bs_') == -1
  ) {
    // eslint-disable-next-line
    for (var x in messageObject.labeledTagTable) {
      // eslint-disable-next-line
      if (text.indexOf(`>@${x.substring(3)}<`) !== -1) {
        break;
      }

      // eslint-disable-next-line
      let strIndexStart = x.includes('liperson_') ? 9 : 3;

      text = text.replace(
        // eslint-disable-next-line
        `@${x.substring(strIndexStart)}`,
        _.bind(
          function (match) {
            let urlId = null;
            let urlIdMatch;
            const tagRegex = /:{1}[^:\s](.+[^\]])/gim;

            if (
              this.index.indexOf('fb_') !== -1
              || this.index.indexOf('li_') !== -1
              || this.index.indexOf('liperson_') !== -1
            ) {
              urlIdMatch = tagRegex.exec(
                this.messageObject.labeledTagTable[this.index],
              );

              if (urlIdMatch === null) {
                return match;
              }

              urlId = urlIdMatch[0].substr(1);
            }

            if (this.index.indexOf('fb_') !== -1) {
              return (
                `<a target='_blank' data-bypass href='https://www.facebook.com/${
                  urlId
                }' class='facebook-tag-it' data-mce-href='http://www.facebook.com/${
                  urlId
                }'>${
                  match
                }</a>`
              );
            }

            if (this.index.indexOf('liperson_') !== -1) {
              const userDetails = loginContext.getDefaultLoginDetails();
              const liHref = `${window.api_url}/api/v3/linkedin/person_profile_redirect?username=${
                userDetails.username
              }&access_token=${
                userDetails.accessToken
              }&person_id=${
                urlId
              }&account_id=${
                window.Utils.liCompanyPageAccountID
              }`;

              return (
                `<a target='_blank' data-bypass href='${liHref}' class='linkedin-tag-it' data-mce-href='${liHref}'>${
                  match
                }</a>`
              );
            }

            if (this.index.indexOf('li_') !== -1) {
              return (
                `<a target='_blank' data-bypass href='https://www.linkedin.com/company/${
                  urlId
                }' class='linkedin-tag-it' data-mce-href='https://www.linkedin.com/company/${
                  urlId
                }'>${
                  match
                }</a>`
              );
            }
          },
          {
            messageObject,
            // eslint-disable-next-line
            index: x,
          },
        ),
      );
    }

    return text;
  }

  if (
    messageObject
    && messageObject.source_url
    && messageObject.source_url.toLowerCase().indexOf('facebook') !== -1
  ) {
    // User is in FB page stream
    useFBLinks = true;
  } else if (
    messageObject
    && messageObject.recipients
    && messageObject.recipients.length
  ) {
    // check services to determine if we should linkify facebook tags or twitter tags.
    if (checkAccountTypePresent(messageObject.recipients, 'facebook')) {
      useFBLinks = true;
    }

    if (checkAccountTypePresent(messageObject.recipients, 'threads')) {
      useThreadsLinks = true;
    }

    if (checkAccountTypePresent(messageObject.recipients, 'bluesky')) {
      useBlueskyLinks = true;
    }
  }

  if ((forceCheckFBTags && messageObject.facebookTagTable) || useFBLinks) {
    // eslint-disable-next-line
    for (var x in messageObject.facebookTagTable) {
      text = text.replace(
        // eslint-disable-next-line
        `@${x}`,
        _.bind(
          function (match) {
            return convertTagToLink.apply(this, [match]);
          },
          {
            messageObject,
            // eslint-disable-next-line
            index: x,
          },
        ),
      );
    }
  } else {
    // Twitter or threads linkify
    text = text.replace(
      /(^|[\s])(@([\w.-]+\b(?!\s*<\/a))(?!\s*["']))/gi,
      (matchText, matchPreceedingChars, matchMention) => {
        let hasDot = '';

        if (
          matchMention
          && matchMention.charAt(matchMention.length - 1) == '.'
        ) {
          matchMention = matchMention.substr(0, matchMention.length - 1);
          hasDot = '.';
        }

        if (typeof isInstagram !== 'undefined' && isInstagram) {
          return (
            `${matchPreceedingChars
            }<a target="_blank" data-bypass class="${
              linkClass
            } instagram-profile" data-user-handle="${
              matchMention.replace('@', '')
            }" href="http://instagram.com/${
              matchMention.replace(/^@/, '')
            }/">${
              matchMention
            }</a>${
              hasDot}`
          );
        }
        if (useThreadsLinks) {
          return (
            `${matchPreceedingChars
            }<a target="_blank" data-bypass class="${
              linkClass
            } threads-profile" data-user-handle="${
              matchMention.replace('@', '')
            }" href="https://www.threads.net/@${
              matchMention.replace(/^@/, '')
            }/">${
              matchMention
            }</a>${
              hasDot}`
          );
        }
        if (useBlueskyLinks) {
          return (
            `${matchPreceedingChars
            }<a target="_blank" data-bypass class="${
              linkClass
            } bluesky-profile" data-user-handle="${
              matchMention.replace('@', '')
            }" href="https://bsky.app/profile/${
              matchMention.replace(/^@/, '')
            }/">${
              matchMention
            }</a>${
              hasDot}`
          );
        }
        return (
          `${matchPreceedingChars
          }<a target="_blank" data-bypass class="${
            linkClass
          } twitter-profile" data-user-handle="${
            matchMention.replace('@', '')
          }" href="http://twitter.com/${
            matchMention
          }">${
            matchMention
          }</a>${
            hasDot}`
        );
      },
    );
  }

  return text;
}

function extractLinks(text) {
  const source = (text || '').toString();
  const urlArray = [];
  let matchArray;

  // Regular expression to find FTP, HTTP(S) and email URLs.
  const regexToken = /(((ftp|https?):\/\/)[-\w@;:%_+.~#!?,&//=()]+)|((mailto:)?[_.\w-+]+@([\w][\w-]+\.)+[a-zA-Z]{2,3})/gi;

  // Iterate through any URLs in the text.
  // eslint-disable-next-line
  while ((matchArray = regexToken.exec(source)) !== null) {
    const token = matchArray[0];
    if (token.length >= 13) {
      // e.g. http://cn.co
      urlArray.push(token);
    }
  }

  const url = urlArray[0];
  // remove last ')' if no '('
  if (url && url.lastIndexOf(')') == url.length - 1 && url.indexOf('(') == -1) {
    urlArray[0] = url.substr(0, url.length - 1);
  }

  return urlArray;
}

window.truncate = truncate;
window.linkify = linkify;
window.extractLinks = extractLinks;
window.isValidImage = isValidImage;
window.replaceAll = replaceAll;
window.trim = trim;

export default global;
export {
  truncate,
  linkify,
  extractLinks,
  isValidImage,
  replaceAll,
  trim,
};
